import { useState } from 'react';
import Layout from '../components/shared/Layout';
import { Calculator, Bell, Droplets, Info } from 'lucide-react';
import ExtinguisherCalculator from '../components/calculators/ExtinguisherCalculator';
import DetectionCalculator from '../components/calculators/DetectionCalculator';
import WaterDefenseCalculator from '../components/calculators/WaterDefenseCalculator';

export default function CalculatorsPage() {
    const [activeTab, setActiveTab] = useState<'extinguisher' | 'detection' | 'water'>('extinguisher');

    return (
        <Layout>
            <div className="min-h-screen p-8 animate-fadeIn">
                {/* Header */}
                <div className="mb-8">
                    <div className="flex items-center gap-3 mb-2">
                        <div className="tech-label">
                            <span className="inline-block w-2 h-2 rounded-full bg-ember-500 mr-2 animate-pulse" />
                            COMPLIANCE SUITE
                        </div>
                    </div>
                    <h1 className="text-4xl font-bold text-white mb-2">
                        Regulatory Calculators
                    </h1>
                    <p className="text-gray-400">
                        Professional sizing tools based on APSAD R4, Rule R7, and D9 standards
                    </p>
                </div>

                {/* Navigation Tabs */}
                <div className="flex flex-wrap gap-4 mb-8">
                    <button
                        onClick={() => setActiveTab('extinguisher')}
                        className={`flex items-center gap-3 px-6 py-4 rounded-xl border transition-all duration-300 ${activeTab === 'extinguisher'
                            ? 'bg-ember-500/10 border-ember-500 text-white shadow-[0_0_20px_rgba(255,107,53,0.2)]'
                            : 'bg-black/40 border-[var(--blueprint-line)] text-gray-500 hover:border-gray-500 hover:text-gray-300'
                            }`}
                    >
                        <Calculator className="w-5 h-5" />
                        <div className="text-left">
                            <div className="text-sm font-semibold">Extinguishers</div>
                            <div className="text-xs opacity-60">APSAD R4</div>
                        </div>
                    </button>

                    <button
                        onClick={() => setActiveTab('detection')}
                        className={`flex items-center gap-3 px-6 py-4 rounded-xl border transition-all duration-300 ${activeTab === 'detection'
                            ? 'bg-ember-500/10 border-ember-500 text-white shadow-[0_0_20px_rgba(255,107,53,0.2)]'
                            : 'bg-black/40 border-[var(--blueprint-line)] text-gray-500 hover:border-gray-500 hover:text-gray-300'
                            }`}
                    >
                        <Bell className="w-5 h-5" />
                        <div className="text-left">
                            <div className="text-sm font-semibold">Fire Detection</div>
                            <div className="text-xs opacity-60">Rule R7</div>
                        </div>
                    </button>

                    <button
                        onClick={() => setActiveTab('water')}
                        className={`flex items-center gap-3 px-6 py-4 rounded-xl border transition-all duration-300 ${activeTab === 'water'
                            ? 'bg-ember-500/10 border-ember-500 text-white shadow-[0_0_20px_rgba(255,107,53,0.2)]'
                            : 'bg-black/40 border-[var(--blueprint-line)] text-gray-500 hover:border-gray-500 hover:text-gray-300'
                            }`}
                    >
                        <Droplets className="w-5 h-5" />
                        <div className="text-left">
                            <div className="text-sm font-semibold">Water Defense</div>
                            <div className="text-xs opacity-60">Doc D9</div>
                        </div>
                    </button>
                </div>

                {/* Tool Content w/ Disclaimer */}
                <div className="mb-6 flex items-start gap-3 p-4 rounded-lg bg-blue-500/10 border border-blue-500/20 text-blue-200 text-sm">
                    <Info className="w-5 h-5 shrink-0 mt-0.5" />
                    <p>
                        These results are for pre-sizing and estimation purposes only. All final designs must be validated by a certified safety engineer as per NFS standards.
                    </p>
                </div>

                {activeTab === 'extinguisher' && <ExtinguisherCalculator />}

                {activeTab === 'detection' && <DetectionCalculator />}

                {activeTab === 'water' && <WaterDefenseCalculator />}
            </div>
        </Layout>
    );
}
